var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"class-name":"account","value":_vm.showAccountModal,"width":"430","footer-hide":""},on:{"on-visible-change":_vm.onVisibleChange}},[_c('AccountContainer',{ref:"accountContainer",on:{"success":_vm.loginSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }